import React from 'react'

const subscribeArrowRight = () => {
    return ( <svg width="26" height="15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m18.595.823-.177-.177-.177.177-1.07 1.07-.176.176.177.177 4.33 4.33H.75v2.012h20.752l-4.33 4.33-.177.177.177.177 1.069 1.07.177.176.177-.177 6.582-6.582.177-.177-.177-.177L18.595.823Z" fill="#fff" stroke="#000" strokeWidth=".5"/></svg> );
}
 
export default subscribeArrowRight;